/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TableViewsLimitsTraitDTO
 */
export interface TableViewsLimitsTraitDTO {
    /**
     * 
     * @type {number}
     * @memberof TableViewsLimitsTraitDTO
     */
    maxTableViewsPerProject?: number;
}

/**
 * Check if a given object implements the TableViewsLimitsTraitDTO interface.
 */
export function instanceOfTableViewsLimitsTraitDTO(value: object): value is TableViewsLimitsTraitDTO {
    return true;
}

export function TableViewsLimitsTraitDTOFromJSON(json: any): TableViewsLimitsTraitDTO {
    return TableViewsLimitsTraitDTOFromJSONTyped(json, false);
}

export function TableViewsLimitsTraitDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TableViewsLimitsTraitDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'maxTableViewsPerProject': json['maxTableViewsPerProject'] == null ? undefined : json['maxTableViewsPerProject'],
    };
}

export function TableViewsLimitsTraitDTOToJSON(value?: TableViewsLimitsTraitDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'maxTableViewsPerProject': value['maxTableViewsPerProject'],
    };
}

